import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { IRewardsPointsProgram, WALLET_CODE } from '@libs/interfaces';
import { IConversionStrategy } from '@libs/helper/settings/rpp.helper';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RppService {
  constructor(private api: ApiService) {}
  fetchUserLoyaltyPointsList(
    user_id: string,
    offset: number,
    limit: number,
  ): Promise<{ list: IRewardsPointsProgram[]; total: number; offset: number; limit: number; total_points: number }> {
    return this.api
      .post(`rpp/user/loyalty/points/list`, {
        user_id,
        offset,
        limit,
      })
      .toPromise();
  }
  fetchUserLoyaltyPointsTotal(user_id: string): Promise<number> {
    return this.api.post(`rpp/user/loyalty/points/total`, { user_id }).toPromise();
  }
  fetchRppConversionStrategies(wallet: WALLET_CODE): Promise<IConversionStrategy> {
    return this.api.get(`rpp/conversion-strategies/${wallet}`).toPromise();
  }
  convertLoyaltyPoints(user_id: string, amount: number, wallet: WALLET_CODE): Observable<any> {
    return this.api.post(`rpp/user/loyalty/points/convert`, { user_id, amount, wallet });
  }
}
